// Utils
import emptyArrayOr from 'fc-utils/emptyArrayOr'
import _map from 'lodash/map'
import _snakeCase from 'lodash/snakeCase'

// Constants
import {
  JOB_STATUS_OPTIONS,
} from 'fc-model-sampling-jobs'

// Exports
export default function () {
  return emptyArrayOr(_map(JOB_STATUS_OPTIONS, function (STATUS) {
    return {
      value: _snakeCase(STATUS),
      label: STATUS,
    }
  }))
}
